import { restClient } from '@/Core'

import { APPLICATION_REST_URL } from '../Contracts/IApplication'

import type { ApplicationCollectionResponse, ApplicationRecord } from '../Contracts/IApplication'

export interface LoadOwnerApplicationsParams {
    /** Поле власника в заявці: `client` або `carrier` */
    ownerField: 'client' | 'carrier'
    ownerUuid: string
    page: number
    pageSize: number
}

/**
 * Сторінка заявок одного клієнта чи перевізника для вкладки «Заявки» його
 * картки (`SPEC-021` §8.9): `filters` ядра з умовою `<власник>.uuid`, порядок —
 * як у реєстрі. Права рядка (R-A) накладає бек.
 *
 * `forceRefresh`: ядровий клієнт кешує GET, а після збереження заявки в
 * шухляді список мусить показати зміну.
 */
export const LoadOwnerApplicationsTask = async ({
    ownerField,
    ownerUuid,
    page,
    pageSize,
}: LoadOwnerApplicationsParams): Promise<{ items: ApplicationRecord[]; total: number }> => {
    const filters = encodeURIComponent(JSON.stringify({ and: [{ field: `${ownerField}.uuid`, op: '=', value: ownerUuid }] }))
    const raw = await restClient.get(`${APPLICATION_REST_URL}?page=${page}&limit=${pageSize}&filters=${filters}`, undefined, {
        forceRefresh: true,
    })
    const data = raw as unknown as ApplicationCollectionResponse | null
    const items = (data?.items ?? []).filter((item) => typeof item?.uuid === 'string')
    const total = typeof data?.meta?.total === 'number' ? data.meta.total : items.length

    return { items, total }
}
